
import api from '../token';

export const CancelarPedidoOnly = async (produto) => {
  try {
    const response = await api.post('/CancelarPedidosMesaOnly', produto);
    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar produto:', error);
    return { success: false, message: error.message };
  }
};



